import React, { useState } from 'react';

const POSTER = '/img/hero-poster.webp';

// Still image instead of video when the visitor asks for less motion or to save data.
const prefersStill = () => {
    if (typeof window === 'undefined') return true;
    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    const saveData = navigator.connection?.saveData;
    return Boolean(reduced || saveData);
};

/**
 * Slow loop of the empty stage behind the home page logo (generated in Higgsfield from
 * src/assets/L1570279.jpg). Sits absolutely inside a positioned parent.
 */
const HeroVideo = () => {
    const [still] = useState(prefersStill);

    return (
        <div className="hero-media" aria-hidden="true">
            {still ? (
                <img src={POSTER} alt="" className="hero-media-el" />
            ) : (
                <video className="hero-media-el" autoPlay muted loop playsInline preload="auto" poster={POSTER}>
                    <source src="/video/hero-720.mp4" type="video/mp4" media="(max-width: 720px)" />
                    <source src="/video/hero.mp4" type="video/mp4" />
                </video>
            )}
            <div className="hero-media-shade" />
            <style>{`
                .hero-media { position: absolute; inset: 0; overflow: hidden; z-index: 0; }
                .hero-media-el { width: 100%; height: 100%; object-fit: cover; display: block; }
                .hero-media-shade {
                    position: absolute; inset: 0;
                    background:
                        radial-gradient(ellipse 40% 60% at 50% 50%, rgba(10,10,10,0.72) 0%, rgba(10,10,10,0) 100%),
                        linear-gradient(180deg, rgba(10,10,10,0.75) 0%, rgba(10,10,10,0.25) 25%, rgba(10,10,10,0.25) 70%, #0a0a0a 100%);
                }
            `}</style>
        </div>
    );
};

export default HeroVideo;
